import { render } from "./unitDashboard.vue?vue&type=template&id=657d968c&scoped=true"
import script from "./unitDashboard.vue?vue&type=script&lang=js"
export * from "./unitDashboard.vue?vue&type=script&lang=js"

import "./unitDashboard.vue?vue&type=style&index=0&id=657d968c&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/drk-hurricane.de/test-helfer.drk-hurricane.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657d968c"]])

export default __exports__